/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.1.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2023 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
//import Vue from 'vue/dist/vue.min.js'
import axios from "axios";
import store from "./vuex/store"; // vuex store instance

import VueRouter from "vue-router";

import 'bootstrap' 

import App from "./App.vue";
import Cookies from "js-cookie";
// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

window.axios = require("axios");
// router setup
import routes from "./routes/routes";

import "./registerServiceWorker";
// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);


import "sweetalert2/src/sweetalert2.scss";

import swal from 'sweetalert2';
window.Swal = swal;
//window.Swal = require("sweetalert2");

window.Moment = require("moment");
window.Moment.locale("es");

//import 'vue-awesome/icons'
import 'vue-awesome/icons/home'
import 'vue-awesome/icons/users'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/user-graduate'
import 'vue-awesome/icons/user-tie'
import 'vue-awesome/icons/credit-card'
import 'vue-awesome/icons/file-alt'
import 'vue-awesome/icons/bell'
import 'vue-awesome/icons/search'
import 'vue-awesome/icons/money-bill'
import 'vue-awesome/icons/eye'
import 'vue-awesome/icons/trash'
import 'vue-awesome/icons/minus-square'
import 'vue-awesome/icons/check-square'
import 'vue-awesome/icons/edit'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/question'
import 'vue-awesome/icons/bars'
import 'vue-awesome/icons/dollar-sign'
import 'vue-awesome/icons/hand-pointer'
import 'vue-awesome/icons/thumbs-down'
import 'vue-awesome/icons/thumbs-up'
import 'vue-awesome/icons/clipboard-list'
import 'vue-awesome/icons/cog'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/angle-left'
import 'vue-awesome/icons/angle-right'
import 'vue-awesome/icons/school'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/download'
import 'vue-awesome/icons/paper-plane'
import 'vue-awesome/icons/sync'
import 'vue-awesome/icons/key'
import 'vue-awesome/icons/chevron-down'
import 'vue-awesome/icons/play-circle'
import 'vue-awesome/icons/paperclip'
import 'vue-awesome/icons/photo-video'
import 'vue-awesome/icons/newspaper'
import 'vue-awesome/icons/calendar'
import 'vue-awesome/icons/sign-in-alt'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/comments'
import 'vue-awesome/icons/file-pdf'
import 'vue-awesome/icons/microphone'
/* Register component with one of 2 methods */

import Icon from 'vue-awesome/components/Icon'

import VueDatePicker from '@mathieustan/vue-datepicker';

Vue.use(VueDatePicker);

// Options: You can set lang by default
Vue.use(VueDatePicker, {
  lang: 'es'
});

// globally (in your main .js file)
Vue.component('v-icon', Icon)

axios.interceptors.request.use(
  function(config) {
    config["headers"] = {
      Authorization: "Bearer " + Cookies.get("access_token"),
      tokentap:'Sb7qmGAxCrqdZz370F5cGSNrcQNidjQ2',
      Accept: "application/json"
    };
    config["onUploadProgress"] = progressEvent => {
     /* store.dispatch(
        "update_upload_percentage",
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      );*/
    };

    return config;
  },
  error => Promise.reject(error)
);
import jQuery from 'jquery'
window.jQuery = jQuery
// Importamos JQuery
const $ = require('jquery')
// Lo declaramos globalmente
window.$ = $

import * as Config from "./config"
// configure router

/*const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});*/

import Toaster from 'v-toaster'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader

import 'v-toaster/dist/v-toaster.css'
// optional set default imeout, the default is 10000 (10 seconds).

Vue.use(Toaster, { timeout: 5000 })


import router from './routes/routes'

Vue.config.ignoredElements = [/^ion-/];
/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store: store,
  components: { App }
});
